export default __webpack_public_path__ + "static/media/535.5b33e7a4.png";